<template lang="html">
  <div class="row">
    <div class="general-info-card pl-box-shadow pa2 center-xs">
      <div class="general-info-data mv3">
        {{ numberOfTeachersThatCreatedAtLeastOneRt }}
      </div>
      <div
        class="row col-xs no-margin no-padding middle-xs center-xs general-info-label"
      >
        Teachers That Created At Least One Roundtable
      </div>
      <div class="mt3">
        <i
          v-my-tooltip="teachers_that_created_at_least_one_roundtable"
          class="fa fa-info-circle"
          style="color: #848484"
          aria-hidden="true"
        />
      </div>
    </div>
    <div class="general-info-card pl-box-shadow pa2 center-xs">
      <div class="general-info-data mv3">
        {{ numberActiveStudents }}
      </div>
      <div
        class="row col-xs no-margin no-padding middle-xs center-xs general-info-label"
      >
        Active Students
      </div>
      <div class="mt3">
        <i
          v-my-tooltip="teachers_that_created_at_least_one_roundtable"
          class="fa fa-info-circle"
          style="color: #848484"
          aria-hidden="true"
        />
      </div>
    </div>

    <div class="general-info-card pl-box-shadow pa2 center-xs">
      <div class="general-info-data mv3">
        {{ numberOfTeachersThatRanAtLeastOneRt }}
      </div>
      <div
        class="row col-xs no-margin no-padding middle-xs center-xs general-info-label"
      >
        Teachers That Ran At Least One Roundtable
      </div>
      <div class="mt3">
        <i
          v-my-tooltip="teachers_that_ran_at_least_one_roundtable"
          class="fa fa-info-circle"
          style="color: #848484"
          aria-hidden="true"
        />
      </div>
    </div>

    <div
      @click="$emit('showRoundtablesInfo', 'daily_list_of_roundtables_created')"
      class="general-info-card pl-button pl-box-shadow pa2 center-xs cursor-pointer"
    >
      <div class="general-info-data mv3">
        {{ numberActivitiesCreated }}
      </div>
      <div
        class="row col-xs no-margin no-padding middle-xs center-xs general-info-label"
      >
        Written RoundTables Created
      </div>
      <div class="mt3">
        <i
          v-my-tooltip="roundtable_discussions_created_tooltip"
          class="fa fa-info-circle"
          style="color: #848484"
          aria-hidden="true"
        />
      </div>
    </div>

    <div
      @click="$emit('showRoundtablesInfo', 'daily_list_of_roundtables_run')"
      class="general-info-card pl-box-shadow pa2 center-xs"
    >
      <div class="general-info-data mv3">
        {{ numberActivitiesRun }}
      </div>
      <div
        class="row col-xs no-margin no-padding middle-xs center-xs general-info-label cursor-pointer"
      >
        Written RoundTables Run
      </div>
      <div class="mt3">
        <i
          v-my-tooltip="roundtable_discussions_run_tooltip"
          class="fa fa-info-circle"
          style="color: #848484"
          aria-hidden="true"
        />
      </div>
    </div>
    <div
      @click="
        $emit('showRoundtablesInfo', 'daily_list_of_live_discussions_created')
      "
      class="general-info-card pl-box-shadow pa2 center-xs cursor-pointer"
    >
      <div class="general-info-data mv3">
        {{ numberOfLiveDiscussionsCreated }}
      </div>
      <div
        class="row col-xs no-margin no-padding middle-xs center-xs general-info-label"
      >
        Verbal RoundTables Created
      </div>
      <div class="mt3">
        <i
          v-my-tooltip="live_discussions_created_tooltip"
          class="fa fa-info-circle"
          style="color: #848484"
          aria-hidden="true"
        />
      </div>
    </div>
    <div
      @click="
        $emit('showRoundtablesInfo', 'daily_list_of_live_discussions_run')
      "
      class="general-info-card pl-box-shadow pa2 center-xs cursor-pointer"
    >
      <div class="general-info-data mv3">
        {{ numberOfLiveDiscussionsRun }}
      </div>
      <div
        class="row col-xs no-margin no-padding middle-xs center-xs general-info-label"
      >
        Verbal RoundTables Run
      </div>
      <div class="mt3">
        <i
          v-my-tooltip="live_discussions_run_tooltip"
          class="fa fa-info-circle"
          style="color: #848484"
          aria-hidden="true"
        />
      </div>
    </div>
    <div class="general-info-card pl-box-shadow pa2 center-xs">
      <div class="general-info-data mv3">
        {{ numberOfRtsCreatedFromUniverse }}
      </div>
      <div
        class="row col-xs no-margin no-padding middle-xs center-xs general-info-label"
      >
        RoundTables Created From Universe
      </div>
      <div class="mt3">
        <i
          v-my-tooltip="roundtable_discussions_created__from_universe_tooltip"
          class="fa fa-info-circle"
          style="color: #848484"
          aria-hidden="true"
        />
      </div>
    </div>
    <!-- <adminPortalAnalyticsNumberOfRtsGraph
      :analyticsNumberOfRts="analytics_number_of_rts"
    /> -->
  </div>
</template>
<script>
  import adminPortalAnalyticsNumberOfRtsGraph from './../../analytics/standardGraphs/numberOfRtsGraph.vue';
  import adminServices from 'services/admin/adminServices';
  export default {
    components: {
      adminPortalAnalyticsNumberOfRtsGraph,
    },
    data() {
      return {
        analytics_number_of_rts: [],
        teachers_that_created_at_least_one_roundtable:
          'This is the number of students who have been invited to at least one RoundTable between the dates selected.',
        teachers_that_ran_at_least_one_roundtable:
          'This is the total number of Teachers that have run at least one roundtable between the selected dates.',
        roundtable_discussions_created_tooltip:
          'This is the total number of RoundTables that were created by teachers between the selected dates.',
        roundtable_discussions_run_tooltip:
          'This is the total number of RoundTables with invited students that were created by teachers between the selected dates.',
        live_discussions_created_tooltip:
          'This is the total number of Verbal Discussions that were created by teachers between the selected dates.',
        live_discussions_run_tooltip:
          'This is the total number of Verbal Discussions with invited students that were created by teachers between the selected dates.',
        roundtable_discussions_created__from_universe_tooltip:
          'This is the total number of RoundTables that were created by teachers from universe between the selected dates.',
      };
    },
    props: {
      numberOfTeachersThatCreatedAtLeastOneRt: {
        type: Number,
        default: 0,
      },
      numberActiveStudents: {
        type: Number,
        default: 0
      },
      numberOfTeachersThatRanAtLeastOneRt: {
        type: Number,
        default: 0,
      },
      numberActivitiesCreated: {
        type: Number,
        default: 0,
      },
      numberActivitiesRun: {
        type: Number,
        default: 0,
      },
      numberOfLiveDiscussionsCreated: {
        type: Number,
        default: 0,
      },
      numberOfLiveDiscussionsRun: {
        type: Number,
        default: 0,
      },
      numberOfRtsCreatedFromUniverse: {
        type: Number,
        default: 0,
      },
    },
    methods: {
      getRoundtables() {
        const schoolID = this.$router.params.schoolID;
        adminServices
          .getSchoolAnalyticsNumberOfRts(schoolID, 'values')
          .then((res) => {
            this.analytics_number_of_rts = res.data;
          });
      },
      showRoundtablesInfo() {
        this.$emit('showRoundtablesInfo', 'daily_list_of_roundtables_created');
        //console.log('daily_list_of_roundtables_created');
      },
    },
  };
</script>
<style scoped lang="stylus">
  .general-info-card
    width: 200px;
    margin: 0 10px 20px 10px
  .general-info-data
    font-size: 32px
    font-weight: 600

  .general-info-label
    min-height: 60px;
    font-size: 16px;
    text-align:center
</style>



// WEBPACK FOOTER //
// adminViewAnalyticsGeneralInfo.vue?2fc69991